import React from "react";
import * as Yup from "yup";
import moment from "moment";
import API from "../../../API";
import CRUDTable from "../../../Shared/CRUDTable";
import { Roles } from "../../../../constants";
import * as validationSchemas from "../../../validationSchemas";

const validationSchema = Yup.object({
  name: validationSchemas.readableText.label("Name").required(),
  email: validationSchemas.email.label("Email").required(),
  phone: validationSchemas.phone.label("Phone number").required(),
  pw: validationSchemas.password.label("Password").required(),
});

const Surevy = () => {
  return (
    <CRUDTable
      API={API("survey")}
      idExtractor={(data) => data.a_id}
      tableName="Survey"
      hideEditButton
      hideDeleteButton
      hideAddButton
      config={{
        columns: [
          {
            label: "Question",
            db_name: "question",
            gridOptions: { md: 12 },
          },
          {
            label: "answer",
            db_name: "answer",
            gridOptions: { md: 6 },
            
          },
           {
            label: "Language",
            db_name: "language",
            gridOptions: { md: 6 },
            
          },
           {
            label: "Phone",
            db_name: "u_phone",
            gridOptions: { md: 6 },
            
          },
          {
            label: "Mobile",
            db_name: "a_mobile",
            gridOptions: { md: 6 },
            
          },
           {
            label: "Email",
            db_name: "a_email",
            gridOptions: { md: 6 },
            
          },
           {
            label: "Name",
            db_name: "a_name",
            gridOptions: { md: 6 },
            
          },
           {
            label: "Center",
            db_name: "Cost_Cen_Name",
            gridOptions: { md: 6 },
            
          },
           {
            label: "IP",
            db_name: "ip",
            gridOptions: { md: 6 },
            
          },
          {
            label: "CreatedAt",
            db_name: "createdAt",
            gridOptions: { md: 6 },
            
          },
         
        ],
        formikProps: {
          validationSchema,
        },
      }}
    />
  );
};

export default Surevy;
